export default __webpack_public_path__ + "static/media/community.b4c11132.mp4";